import React, { type FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from './AdminAuthContainer';
import UserState from '../../components/common/userState/UserState';
import ClassLogoForHeaderFull from '../../icons/ClassLogoForHeaderFull';

export const SETTINGS_HEADER_HEIGHT = '80px';

const SharedStyles = css`
    height: ${SETTINGS_HEADER_HEIGHT};
    background-color: #ffffff;
    border-bottom: 1px solid #d8d8d8;
`;

const StyledImageContainer = styled.div`
    ${SharedStyles};
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    display: flex;
    align-items: center;

    padding: 0 2rem;
`;

const StyledHeaderTextContainer = styled.div`
    ${SharedStyles};
    grid-row: 1 / 2;
    grid-column: 2 / 3;
    display: flex;
    align-items: center;
    padding: 0 1rem;
`;

/* TODO: Replace this with class or theme `Title L` */
const StyledHeaderText = styled.span`
    font-family: Lato;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: left;
`;

const StyledHeaderRightContainer = styled.div`
    grid-row: 1 / 2;
    grid-column: 3 / 4;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 2rem;
`;
// eslint-disable-next-line arrow-body-style
const SettingsHeader: FunctionComponent = () => {
    const { t } = useTranslation('admin_settings');
    const { user, isLoggedIn } = useContainer(AdminAuthContainer);
    const name = user?.user_name || '';
    const email = user?.email || '';

    return (
        <>
            <StyledImageContainer>
                <ClassLogoForHeaderFull />
            </StyledImageContainer>
            <StyledHeaderTextContainer>
                <StyledHeaderText>{t('header.settings')}</StyledHeaderText>
            </StyledHeaderTextContainer>
            <StyledHeaderRightContainer>
                <UserState name={name} email={email} />
            </StyledHeaderRightContainer>
        </>
    );
};

export default SettingsHeader;
